<template>
  <van-popup
    v-model:show="popupVisible"
    position="center"
    :overlay-style="{ backgroundColor: '#00000088' }"
    round
    :style="{ background: '#ffffff00' }"
  >
    <div class="relative rounded-sm bg-white p-4">
      <img
        src="@/assets/images/index/qa-qrcode.png"
        alt="二维码"
        class="h-50 w-50"
        v-on-long-press="longPress"
      />
      <!-- <img
        src="@/assets/images/share-logo.jpg"
        alt=""
        class="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded"
      /> -->
      <div class="mt-3 w-full text-center text-sm text-[#666]">长按识别二维码进入群聊</div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useChannelStore } from '@/stores'
import YouMeng from '@/utils/YouMeng'
import { vOnLongPress } from '@vueuse/components'

const channelStore = useChannelStore()
const popupVisible = computed({
  get: () => channelStore.qaQrcodePopupVisible,
  set: (val) => {
    if (val) {
      channelStore.showQaQrcodePopup()
    } else {
      channelStore.hideQaQrcodePopup()
    }
  },
})

const longPress = () => {
  YouMeng.pushRecord({}, 'gzcmc.xhc.h5.enroll.answer.qr', 'longpress')
}
</script>
